<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <CRow>
                            <CCol sm="7">
                                <div style="margin-top: 20%; position: relative;">
                                    <CButton class="custom-bg-0179FF text-white">✦ 7100+ Image detected ✦</CButton>
                                    <h1 class="font-general-sans text-left custom-72px-500 font-color-2C2C2C" data-aos="fade-left">
                                        AI-Powered Real-Time Image Detection
                                    </h1>
                                    <p class="custom-18px-400">Explore the frontier of tracking technology, where AI and machine learning bring unmatched accuracy, adaptability, and intelligence to the world of cameras. These next-gen systems are designed to think, learn, and track
                                        with precision like never before.</p>
                                    <div class="d-flex">
                                        <CButton class="custom-bg-0179FF text-white">Request A Demo</CButton>
                                        <img src="../assets/img/iconarrowup.png" width="40px" height="40px" class="ml-2" />
                                        <img src="../assets/img/groupuser.png" height="40px" class="ml-2" />
                                    </div>
    
    
                                </div>
                            </CCol>
                            <CCol sm="5">
                                <div class="p-3" style="margin-top: 30%; position: relative;">
                                    <img src="../assets/img/random/imageAi.png" style="max-width:80%" />
    
                                    <!-- Button and Image positioned at the bottom-left -->
    
                                </div>
                            </CCol>
                        </CRow>
    
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-white">
            <CRow>
                <CCol sm="4">
                    <h3 class="custom-48px-600 text-left mt-5 ml-4">
                        Who We <br /> Are
                    </h3>
                </CCol>
                <CCol sm="8">
                    <p class="custom-20px-400 font-color-666D80 text-left mt-5 p-4">
                        We are at the forefront of artificial intelligence development, committed to creating innovative, cutting-edge solutions that drive meaningful change across industries. Our mission is to harness the power of AI to solve complex challenges, optimize business
                        processes, and improve everyday lives
                    </p>
                </CCol>
            </CRow>
        </CCol>
    
        <CCol sm="12">
            <div style="background-size: cover;border-radius:20px" :style="{ backgroundImage: `url(${backgroundUrlBlue})` }">
                <br /> <br />
                <CRow>
                    <CCol sm="4">
                        <div class="m-3">
                            <h3 class="custom-16px-500 text-white text-left">
                                Active Users
                            </h3>
                            <h3 class="custom-48px-600 text-left text-white">1,500+</h3>
                            <p class="custom-16px-400 text-left">Trusted by thousands of users worldwide for security, monitoring, and automation. Join a growing community of AI-driven innovation.</p>
                        </div>
                    </CCol>
                    <CCol sm="4">
                        <div class="m-3">
                            <h3 class="custom-16px-500 text-white text-left">
                                Accuracy Rate
                            </h3>
                            <h3 class="custom-48px-600 text-left text-white">Up to 95%</h3>
                            <p class="custom-16px-400 text-left">Our AI achieves high-precision results with an impressive accuracy rate, even in complex or dynamic settings</p>
                        </div>
                    </CCol>
                    <CCol sm="4">
                        <div class="m-3">
                            <h3 class="custom-16px-500 text-white text-left">
                                Detection Speed
                            </h3>
                            <h3 class="custom-48px-600 text-left text-white">
                                < 1 Second</h3>
                                    <p class="custom-16px-400 text-left">Real-time detection with response times of under one second, delivering instant feedback when you need it most</p>
                        </div>
                    </CCol>
                </CRow>
                <br /> <br />
    
            </div>
        </CCol>
    
        <CCol sm="12" class="mt-5" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrlBlackBlue})` }">
            <div>
                <br /> <br />
                <h3 class="custom-52px-600 text-center mt-5">
                    Why Our AI Detection Stands Out
                </h3>
                <p class="custom-18px-400 text-white text-center mb-4">
                    <CContainer>
                        Our AI-powered image detection system brings together cutting-edge technology, real-time performance, and unparalleled accuracy to meet today’s security and efficiency demands.
                    </CContainer>
                </p>
            </div>
            <CRow class="d-flex">
                <CCol sm="3" class="d-flex">
                    <CCard class="custom-bg-grey-transparent">
                        <img src="../assets/img/icon/click.png" width="50px" />
                        <h3 class="custom-20px-600 font-color-EBF1EF">
                            User-Friendly
                        </h3>
                        <p class="custom-14px-400 font-color-EBF1EF text-center">
                            Our solution is designed with ease of use in mind. With a straightforward interface and seamless integration into your current systems, you can start utilizing real-time image detection without a steep learning curve
                        </p>
                    </CCard>
                </CCol>
                <CCol sm="3" class="d-flex">
                    <CCard class="custom-bg-grey-transparent">
                        <img src="../assets/img/icon/lock.png" width="50px" />
                        <h3 class="custom-20px-600 font-color-EBF1EF">
                            Real-Time Performance
                        </h3>
                        <p class="custom-14px-400 font-color-EBF1EF text-center">
                            Experience the power of real-time detection with minimal latency. Our technology identifies objects in less than a second, allowing you to make timely and informed decisions in dynamic environments.
                        </p>
                    </CCard>
                </CCol>
                <CCol sm="3" class="d-flex">
                    <CCard class="custom-bg-grey-transparent">
                        <img src="../assets/img/icon/mentol.png" width="50px" />
                        <h3 class="custom-20px-600 font-color-EBF1EF">
                            High Accuracy and Precision
                        </h3>
                        <p class="custom-14px-400 font-color-EBF1EF text-center">
                            Our solution is designed with ease of use in mind. With a straightforward interface and seamless integration into your current systems, you can start utilizing real-time image detection without a steep learning curve
                        </p>
                    </CCard>
                </CCol>
                <CCol sm="3" class="d-flex">
                    <CCard class="custom-bg-grey-transparent">
                        <img src="../assets/img/icon/camera.png" width="50px" />
                        <h3 class="custom-20px-600 font-color-EBF1EF">
                            Trainable Image Detection
                        </h3>
                        <p class="custom-14px-400 font-color-EBF1EF text-center">
                            Our system allows you to train it to detect specific objects, providing adaptable solutions tailored to various industries—from customer tracking to monitoring specific items or animals
                        </p>
                    </CCard>
                </CCol>
            </CRow>
        </CCol>
    
        <CCol sm="12" class="bg-white">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <CRow>
                            <CCol sm="6">
                                <div style="margin-top: 20%; position: relative;">
                                    <h1 class="font-general-sans text-left custom-72px-500 font-color-2C2C2C" data-aos="fade-left">
                                        AI-Powered Tracking Cameras for the Future
                                    </h1>
                                    <p class="custom-18px-400">Explore the frontier of tracking technology, where AI and machine learning bring unmatched accuracy, adaptability, and intelligence to the world of cameras. These next-gen systems are designed to think, learn, and track
                                        with precision like never before.</p>
                                    <div class="d-flex">
                                        <CButton class="custom-bg-0179FF text-white">Detail</CButton>
                                        <img src="../assets/img/iconarrowup.png" width="40px" height="40px" class="ml-2" />
                                    </div>
    
    
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="p-3" style="margin-top: 10%; position: relative;">
                                    <img src="../assets/img/imgUser.png" style="max-width:80%" />
    
                                    <!-- Button and Image positioned at the bottom-left -->
                                    <div style="position: absolute; bottom: 30px; left: 50px;" class="d-flex" @click="GoToCamera()">
                                        <!-- Round image positioned slightly above the button -->
                                        <img src="../assets/img/round.png" height="55px" />
                                        <!-- Button positioned slightly below the round image -->
                                        <CButton class="custom-button-white">Try Now</CButton>
                                    </div>
                                </div>
                            </CCol>
                        </CRow>
    
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
    
        <CCol sm="12" class="bg-white">
            <div>
                <h3 class="text-center custom-48px-600">
                    How it Works
                </h3>
                <p class="custom-18px-400 font-color-666D80 text-center">
                    These steps outline the process of using the AI Image Generator, <br /> from choosing a style to saving or sharing the final artwork
                </p>
            </div>
            <CContainer>
                <CRow>
                    <!-- Step 1 Image -->
                    <CCol sm="5">
                        <img src="../assets/img/random/step1.png" style="max-width:100%" />
                        <p class="custom-32px-600 font-color-272835 mt-5 font-general-sans">
                            Position Your Object
                        </p>
                        <p class="custom-18px-500 font-color-666D80 font-general-sans">
                            After training, activate the camera feed for real-time detection. Place objects within the camera frame for optimal detection. Proper lighting helps improve accuracy.
                        </p>
                        <img src="../assets/img/random/step3.png" style="max-width:100%" />
                        <p class="custom-32px-600 font-color-272835 mt-5 font-general-sans">
                            View Real-Time Results
                        </p>
                        <p class="custom-18px-500 font-color-666D80 font-general-sans">
                            Watch as detected objects appear with labels directly on the screen. Monitor object counts and activity directly on the dashboard.
                        </p>
                    </CCol>
    
                    <!-- Round 1 Image and Connecting Dashed Line -->
                    <CCol sm="2" class="d-flex justify-content-center align-items-start position-relative d-sm-down-none">
                        <div class="image-container">
                            <img src="../assets/img/random/round1.png" width="50px" class="image-with-border" />
                            <img src="../assets/img/random/line.png" />
    
                            <img src="../assets/img/random/round2.png" width="50px" class="image-with-border" />
                            <img src="../assets/img/random/line.png" />
    
                            <img src="../assets/img/random/round3.png" width="50px" class="image-with-border" />
                            <img src="../assets/img/random/line.png" />
    
                            <img src="../assets/img/random/round4.png" width="50px" class="image-with-border" />
                        </div>
                    </CCol>
    
                    <!-- Step 3 Image (Optional) -->
                    <CCol sm="5">
                        <p class="custom-32px-600 font-color-272835 font-general-sans mt-5">
                            Object Training
                        </p>
                        <p class="custom-18px-500 font-color-666D80 font-general-sans">
                            Upload images of the objects you want to detect (e.g., cats, people, equipment) to train the system. Our AI will learn to recognize and track these objects in real time.
                        </p>
                        <img src="../assets/img/random/step2.png" style="max-width:100%" />
                        <p class="custom-32px-600 font-color-272835 mt-5 font-general-sans">
                            Adjust Detection
                        </p>
                        <p class="custom-18px-500 font-color-666D80 font-general-sans">
                            Fine-tune parameters like sensitivity or detection mode (e.g., object, face, text) to match your needs.
                        </p>
                        <br /> <br /> <br />
                        <img src="../assets/img/random/step4.png" style="max-width:100%" class="mt-5" />
                    </CCol>
                </CRow>
    
    
    
    
            </CContainer>
    
        </CCol>
    
        <CCol sm="12" class="bg-white mt-5">
    
            <img src="../assets/img/banner1.png" style="max-width:100%;cursor:pointer" @click="GoToCameraOnly" />
            <br /><br />
            <img src="../assets/img/banner2.png" style="max-width:100%;cursor:pointer" @click="GoToOutputOnly" />
            <br /><br /><br /><br />
            <h3 class="custom-48px-600 text-center">
                Train the Detector to Recognize Any <br />Object You Need
            </h3>
            <p class="custom-16px-400 font-color-666D80 text-center" style="width:90%;margin:0 auto;">
                Our AI system can adapt to detect a wide range of objects. Simply upload images of the item or entity you wish to track, and our model will learn to <br />identify it. Perfect for tracking customers, animals, assets, or custom items across
                different industries
            </p>
            <CRow class="d-flex mt-4">
                <CCol sm="4">
                    <img src="../assets/img/random/cat.png" style="max-width:100%" />
                    <img src="../assets/img/random/frame1.png" style="max-width:100%" class="mt-3" />
                </CCol>
                <CCol sm="4" class="d-flex">
                    <CRow>
                        <CCol sm="6" class="p-1">
                            <img src="../assets/img/random/ai1.png" style="max-width:100%" />
                        </CCol>
                        <CCol sm="6" class="p-1">
                            <img src="../assets/img/random/ai2.png" style="max-width:100%" />
                        </CCol>
                        <img src="../assets/img/random/ai3.png" style="max-width:100%" />
                    </CRow>
                </CCol>
                <CCol sm="4">
                    <img src="../assets/img/random/ai4.png" style="max-width:100%" class="p-0" />
                    <CRow class="mt-3">
                        <CCol sm="6">
                            <img src="../assets/img/random/ai5.png" style="max-width:100%" />
                        </CCol>
                        <CCol sm="6">
                            <img src="../assets/img/random/ai6.png" style="max-width:100%" />
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
    
        </CCol>
    
        <CCol sm="12">
            <CRow class="p-2">
                <h3 class="custom-32px-500 font-color-2C2C2C font-inter m-3 text-left mt-5">
                    Companies across diverse industries rely on AI-powered <br />image detection technology.
                </h3>
                <CRow>
                    <CCol sm="4">
                        <img src="../assets/img/random/slide1.png" style="max-width:100%" /></CCol>
                    <CCol sm="4">
                        <img src="../assets/img/random/slide2.png" style="max-width:100%" /></CCol>
                    <CCol sm="4">
                        <img src="../assets/img/random/slide3.png" style="max-width:100%" /></CCol>
                </CRow>
            </CRow>
        </CCol>
    
        <CCol sm="12" class="bg-white mt-5">
            <CRow>
                <CCol sm="10">
                    <h3 class="custom-52px-500 text-left font-color-272835 font-inter">
                        Stay Updated with the <br /> Latest in AI and Image <br /> Detection
                    </h3>
                </CCol>
    
                <CCol sm="2">
                    <div class="d-flex mt-5 text-right">
                        <CButton class="custom-bg-0179FF text-white">Detail</CButton>
                        <img src="../assets/img/iconarrowup.png" width="40px" height="40px" class="ml-2" />
                    </div>
                </CCol>
            </CRow>
        </CCol>
        <CCol sm="12" class="bg-white mt-5">
            <CRow>
                <CCol sm="6">
                    <img src="../assets/img/random/ai-img.png" style="max-width:100%" />
                    <p class="custom-14px-400 font-color-272835 ml-2 mt-3">May 16, 2024</p>
                    <p class="custom-24px-600 font-color-272835 ml-2">The Power of Real-Time Image Detection in Everyday </p>
                    <p class="custom-16px-400 font-color-666D80">Explore how real-time image detection technology is transforming industries from security and retail to healthcare. Learn about the potential applications and the benefits of adopting AI-driven solutions in everyday life.</p>
                </CCol>
                <CCol sm="6">
                    <img src="../assets/img/random/ai-img2.png" style="max-width:100%" />
                    <p class="custom-14px-400 font-color-272835 ml-2 mt-3">May 16, 2024</p>
                    <p class="custom-24px-600 font-color-272835 ml-2">Top 5 Benefits of Using AI for Object Detection </p>
                    <p class="custom-16px-400 font-color-666D80">From enhancing security to automating repetitive tasks, AI-powered object detection offers numerous benefits. Discover the top advantages and why businesses are investing in this technology.</p>
                </CCol>
            </CRow>
        </CCol>
    
        <CCol sm="12">
            <CContainer>
                <h3 class="custom-48px-500 text-center font-inter mt-5 mb-3">Frequently Asked Questions</h3>
                <ToggleCard title="1. Can I customize the system to detect specific objects?">
                    Our AI detection system is highly accurate, with an accuracy rate of up to 95% in optimal conditions.Yes! Our AI allows you to train the detector with images of any object you want to track. Simply upload sample images to get started.
                </ToggleCard>
                <ToggleCard title="2. How do I train the system to recognize a new object?">
                    Split your dataset into training, validation, and test sets to evaluate the model effectively.Train the model using your labeled data, adjusting parameters like learning rate and batch size.Monitor training with metrics like accuracy, loss, and F1 score to avoid overfitting.
                </ToggleCard>
                <ToggleCard title="3. Do I need any special equipment to use this system?">
                    For real-time object recognition, you’ll need a camera to capture live images of the objects. A standard webcam can work, but for better accuracy and specialized applications, you may need high-resolution cameras or specific sensors (like depth sensors).
                </ToggleCard>
                <ToggleCard title="4. Is my video feed secure while using this system?">
                    Implement access controls to restrict who can view or manage the video feed. This may include password protection, multi-factor authentication (MFA), and user roles to limit access only to authorized personnel.
                </ToggleCard>
                <ToggleCard title="5. Can the system detect multiple objects at once?">
                    Yes, many object recognition systems can detect multiple objects at once. This capability is common in systems that use object detection models
                </ToggleCard>
                <ToggleCard title="6. Can I save or download the detection results?">
                    You can save the images or video frames with bounding boxes and labels overlaid to visualize detected objects. This can be done frame-by-frame for video or for individual images in a series.
           </ToggleCard>
                </CContainer>
        </CCol>
    
    
    
    
        <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/banner/Hero.png";
import backgroundUrlBlue from "../assets/img/banner/bannerBlue.png";
import backgroundUrlBlackBlue from "../assets/img/banner/bannerblackblue.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrlBlue,
            backgroundUrlBlackBlue,
            isActive: false,

        };

    },
    created() {
        AOS.init();

    },

    mounted() {




    },
    computed: {

    },
    methods: {

        GoToCamera() {
            this.$router.push("HomepageImage");
        },
        GoToCameraOnly() {
            this.$router.push("Camera");
        },
        GoToOutputOnly() {
            this.$router.push("Output");
        },






    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.image-container {
    position: relative;
    max-width: 100%;
}

.background-image {
    width: 100%;
    height: auto;
}

.overlay-text {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    left: 20px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    color: white;
    padding: 10px;
    text-align: center;
    font-size: 1.2em;
    /* Adjust as needed */
    width: 70%;
    margin: 0 auto;
}

pre {
    white-space: pre-wrap;
    /* Ensures that newlines and spaces are rendered as expected */
    color: #171717;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 27px */
}

.bottom-right-button {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    right: 80px;
    /* Adjust as needed */
    padding: 10px 20px;
    background-color: #007bff;
    /* Button color */
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
}

.bottom-right-button-text {
    position: absolute;
    bottom: 90px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    padding: 10px 20px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #000;
    font-weight: 600;
}

.bottom-right-button:hover {
    background-color: #0056b3;
    /* Hover color */
}

/* .popup-all1 {
    width: 500px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 2%;
    height:70vh;
} */

.popup-all2 {
    width: 900px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 4%;
    z-index: 1;
    height: 90vh;
}

.salary-range {
    padding: 20px;
}

.progress {
    height: 20px;
    background-color: #e9ecef;
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background-color: #007bff;
}

.custom-range {
    width: 100%;
}

.input-container {
    position: relative;
    display: inline-block;
    width: 100%;
}

input[type="text"].custom {
    padding-right: 60px;
    /* Adjust according to button width */
    height: 80px;
}

.verify-button {
    position: absolute;
    right: 2px;
    top: 3px;
    bottom: 3px;
    height: 28px;
    border-radius: 50px;
    background: #928AFD;
    color: #fff;
    /* Optional: Adjust the button height to match the input field */
}

.disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
</style>